import i18n from "../../../../constants/i18n";
import getKhattabatSelectsStore from "../../../../stores/khattabat-stores/selects-store";
import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Text from "../../../../core/et3-text";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const SelectedCount = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const countOfSelectedClients = getKhattabatSelectsStore().selectedCount.get();

  return (
    <ET3Div
      width={300}
      height={100}
      alignItems={"center"}
      fDirection={"row"}
      style={{}}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        isSpan={true}
        text={`${i18n.get("COUNT_SELECTED")}:`}
        style={{}}
        color={""}
      />
      <Et3Margin top={0} bottom={0} left={5} right={0} />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        isSpan={true}
        text={`${countOfSelectedClients}`}
        style={{
          textDecoration: "underline",
          textDecorationColor: colors.all.black
        }}
        color={colors.all.red}
      />
    </ET3Div>
  );
});

export default SelectedCount;
